import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({children}) => {
    const rol = localStorage.getItem('rol');

    if (rol === 'ADMINISTRADOR') {
        return children
    } else {
        return <Navigate to="/login" replace={true} />
    }
    
}

export default PrivateRoute;
